import { useCallback, useEffect, useState } from "react";
import { Avatar, Box, Button, Chip, IconButton, Menu, MenuItem, Switch,Typography, CircularProgress } from "@mui/material";
import { CopyAll, Delete, MoreVert,AssistantOutlined } from "@mui/icons-material";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { toast } from 'sonner';
import api from "../../api";
import ClipboardBox from "../../components/ClipboardBox";
import ViewAssistant from "../Assistant/ViewAssistant";
import { useGetAllPermissions } from ".././utils/getAllPermissions";
import UpdateAssistantModal from "./AssistantModals/UpdateAssistantModal";
import DeleteConfirmationModal from "./AssistantModals/DeleteAssistantModal";
import AssignAssistantModal from "./AssistantModals/AssignAssistantModal";
import LinkIcon from '@mui/icons-material/Link';
import { ChipSx, menuItemSx } from "../../styles/GlobalStyles";
import ShimmerLoader from "../../components/ShimmerLoader";
import ChatDrawer from "../../components/ChatDrawer/ChatDrawer";
import ModalShare from "../../components/ModalShare";
import { capitalizeFirstLetter } from '../../pages/utils/stringCapital';

const AssistantDetails = () => {
    const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
    const [ assistantDetails, setAssistantDetails ] = useState(null);
    const [ open, setOpen ] = useState(false);
    const [ assistantName, setAssistantName ] = useState("");
    const [ assistantType, setAssistantType ] = useState("");
    const [ assistantCategory, setAssistantCategory ] = useState("");
    const [ otherCategory, setOtherCategory ] = useState("");
    const [ logo, setLogo ] = useState(null);
    const [ logoFile, setLogoFile ] = useState(null);
    const [ actions, setActions ] = useState([]);
    const [ menuAnchorEl, setMenuAnchorEl ] = useState(null);
    const [ organizationList, setOrganizationList ] = useState([]);
    const [ organization, setOrganization ] = useState("");
    const [ isDemo, setIsDemo ] = useState(false);
    const [ token, setToken ] = useState("");
    const [ userRole, setUserRole ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const [assistantDescription, setAssistantDescription] = useState('');
    const [validationError, setValidationError] = useState(false);
    const { permissions,getAllPermissions } = useGetAllPermissions();
    const { assistantId, company_id } = useParams();
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [ assistantConfig, setAssistantConfig ] = useState();
    const [ credit, setCredit ] = useState(0)
    const [ isShareAssistantModalOpen, setIsShareAssistantModalOpen ] = useState(false);
    
    // Handle Share Assistant
    const handleShareAssistant = () => {
        setIsShareAssistantModalOpen(true);
    }

    // Assign Assistant
    const handleCloseAssignModal = () => {
    setIsAssignModalOpen(false);
    
    };
    const handleAssign = async () => {
        if (!token) {
            toast.error("Authorization token is missing.");
            return;
        }
        if (!assistantDetails?._id) {
            toast.error("Assistant data is missing.");
            return;
        }
    
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };
    
            let apiEndpoint = "/superadmin/assign-assistant";
            let payload = {
                assistantId: assistantDetails._id
            };
    
            if (organization?.trim() && organization !== "blank") {
                // Assign assistant to the organization
                payload.organizationId = organization;
            } else {
               payload.organizationId = "";
            }
    
            await api.post(apiEndpoint, payload, config);
            setIsAssignModalOpen(false);
            toast.success(organization?.trim() && organization !== "blank" 
            ? "Assistant successfully assigned to a company."
            : "Assistant is no longer assigned to a company."
            );
        } catch (error) {
            console.error("Error assigning/unassigning assistant:", error?.response?.data || error);
            toast.error(error?.response?.data?.message || "Error processing request");
        }  
    };

    // Chat Drawer States
    const handleDrawerOpen = () => {
        setIsDrawerOpen(true);
    };
    const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    };

    // Web Call Function
    const handleWebCall = async () => {
        if (credit <= 0) {
            return toast.error("No credit available");
        }
    
        setLoading(true); // Start loading state
    
        try {
            const response = await api.post(
                "/assistants/initiate-web-call",
                {
                    assistantId: assistantDetails._id,
                    organizationId: localStorage.getItem("Organization"),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            if (response.data && response.data.data) {
                setAssistantConfig(response.data.data);
            } else {
                toast.error("Failed to fetch assistant configuration");
            }
        } catch (error) {
            console.error("Web call initiation error:", error);
            toast.error("An error occurred while initiating the web call");
        } finally {
            setLoading(false); // Stop loading state
        }
    };

    // Get Token
    const getToken = () => {
        const t = JSON.parse(localStorage.getItem('token')).token
        const c = JSON.parse(localStorage.getItem('Credit'))
        setCredit(c);
        setToken(t)
    }

    // Fetching assistant Details
    const fetchAssistantDetails = useCallback(async () => {
        setInitialLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await api.get(`/v1/assistant/${assistantId}`, config);
            setAssistantDetails(response.data.assistant);
            setActions(response.data.actions);
            setOrganization(response.data.assistant.Organization);
            setIsDemo(response.data.assistant?.isDemo || false);
        } catch (error) {
            console.error("Error fetching assistant details:", error);
            setLoading(false);
        }finally {
            setInitialLoading(false);
        }
    }, [ assistantId, token ]);

    // Get Organization List
    const getAllOrganizations = useCallback(async () => {
        try {
            const response = await api.get("/organizations", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    limit: 999
                }
            });

            setOrganizationList(response.data.data?.organizations);
        } catch (error) {
            console.error("Error fetching phone:", error);
        }
    }, [ token ]);

    // Handle Menu States
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpenDeleteModal = (assistantId) => {
        setIsDeleteModalOpen(true);
    };
    
    // Handle Delete Assistant
    const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    };
    const performDelete = async () => {
        try {
            const config = {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            };
            const response = await api.delete(`/v1/assistant/delete/${assistantId}`, config);
            if (response.data && response.data.message) {
              toast.success(response.data.message);
            }
            setIsDeleteModalOpen(false);
            navigate(
              userRole === "SuperAdmin"
                ? "/assistants"
                : `/company/${company_id}/assistants`
            );
        } catch (error) {
            toast.error(error.response.data.details);
            console.error("Error deleting assistant:", error);
        }
    };

    const handleDuplicate = async () => {
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
            }
        };

        await api.post("/v1/assistant/duplicate", { assistantId: assistantId }, config);
        toast.success("Assistant duplicated successfully");
        navigate(
            userRole === "SuperAdmin"
                ? "/assistants"
                : `/company/${company_id}/assistants`
        );
    };

    // Handle Toggle Assistant
    const toggleAssistant = async () => {
        try {
            const response = await api.patch(`/superadmin/toggle-assistant/${assistantDetails._id}`, {
                isDemo: !isDemo
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            toast.success(response.data.message);
        } catch (error) {
            toast.error(error.response.data.message);
            console.error(error);
        }
    }

    //Handle Saving / Publishing Assistant
    const handleUpdateSave = async () => {
        setLoading(true);
        try {
            const assistant = JSON.parse(localStorage.getItem("assistant"));
            const logoData = JSON.parse(localStorage.getItem("Logo")); // Logo metadata and content
            const knowledgeBaseData = JSON.parse(localStorage.getItem("KnowledgeBase")); // Logo metadata and content
    
            const formData = new FormData();
            for (const [ key, value ] of Object.entries(assistant)) {
                if (value) {
                    formData.append(key, value);
                }
            }
    
            if (logoData) {
                // Convert Base64 to Blob
                const byteString = atob(logoData.content.split(',')[ 1 ]);
                const mimeString = logoData.content.split(',')[ 0 ].split(':')[ 1 ].split(';')[ 0 ];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[ i ] = byteString.charCodeAt(i);
                }
                const blob = new Blob([ ab ], { type: mimeString });

                // Append the logo file to the formData
                formData.append("logo", new File([ blob ], logoData.name, { type: logoData.type }));
            }
            if (knowledgeBaseData) {
                formData.append("knowledgeBaseName", knowledgeBaseData.name);
                formData.append("knowledgeBaseSize", knowledgeBaseData.size);
                formData.append("knowledgeBaseType", knowledgeBaseData.type);
                formData.append("knowledgeBaseUrl", knowledgeBaseData.url);
            }else if (assistant?.knowledgeBaseUrl == null) {
                formData.delete("knowledgeBaseName");
                formData.delete("knowledgeBaseSize");
                formData.delete("knowledgeBaseType");
                formData.delete("knowledgeBaseUrl");
            }
    
            const response = await api.patch(`/v1/assistant/update/${assistant._id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                },
            });
    
            const actions = localStorage.getItem('actions');
            if (actions) {
                const parsedActions = JSON.parse(actions);
                for (const action of parsedActions) {
                    if (!action._id) {
                        action.Assistant = assistant._id
                        await api.post("/v1/actions/create-action", action, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`
                            }
                        });
                    } else {
                        if (permissions.includes("update_action")) {
                            await api.put(`/v1/actions/update/${action._id}`, {
                                Type: action.Type,
                                ActionName: action.ActionName,
                                Description: action.Description,
                                InputSchema: action.InputSchema,
                                Url: action.Url,
                            }, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`
                                }
                            });
                        }

                    }
                }
            }

 // Handle actions and other logic...
            toast.success(response.data.message);
            window.location.reload()
        } catch (error) {
            toast.error("Error during save.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handleLogoUpload = (event) => {
        const file = event.target.files[ 0 ];
        if (file) {
            setLogoFile(file);
            setLogo(URL.createObjectURL(file));
        }
    };

    const handleAssistantProfileUpdate = async () => {
        setLoading(true); // Start loading
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            }
        };

        const formData = new FormData();
        formData.append("Name", assistantName);
        formData.append("Type", assistantType);
        formData.append("Category", assistantCategory);
        // Include OtherCategory if Category is set to "Other"
        if (assistantCategory === "Other" && otherCategory) {
            formData.append("OtherCategory", otherCategory);
        }
        formData.append("Description",assistantDescription);
        if (logoFile) {
            formData.append("logo", logoFile);
        }

        try {
            const response = await api.patch(`/v1/assistant/update/${assistantId}`, formData, config);
            fetchAssistantDetails();
            handleClose();
            toast.success(response.data?.message);
        } catch (error) {
            const errorMessage = error.response?.data?.details;
            toast.error(errorMessage);
            console.error("Error updating assistant:", errorMessage);
        } finally {
            setLoading(false); // End loading
        }
    };

    //Use Effects
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("User"));
        setUserRole(userData?.Role || "");
    }, []);

    useEffect(() => {
        getToken()
        if (token) {
            
            const initializeData = async () => {
                setLoading(true);
                try {
                    if (token) {
                        await getAllPermissions();
                        await fetchAssistantDetails();
                        await getAllOrganizations();
                    }
                } catch (error) {
                    console.error("Error initializing data:", error);
                } finally {
                    setLoading(false);
                }
            };

            initializeData();
            
        }

    }, [ token ,getAllPermissions, fetchAssistantDetails, getAllOrganizations ]);

    useEffect(() => {
        if (assistantDetails) {
            setAssistantName(assistantDetails?.Name || "");
            setAssistantType(assistantDetails?.Type || "");
            setAssistantCategory(assistantDetails?.Category || "");
            setOtherCategory(assistantDetails?.OtherCategory || "");
            setLogo(assistantDetails?.Logo?.fileUrl || null);
            setAssistantDescription(assistantDetails?.Description);
        }
    }, [ assistantDetails ]);
    if (initialLoading) {
        return (
           <ShimmerLoader/>
        );
    }
    return (
        <>
        <Box>
             <Navbar title="View Assistant" />
        </Box>
                {assistantDetails && (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: 4 }}>
                        <Box
                            sx={{
                                p: 3,
                                bgcolor: "#ffffff",
                                borderColor: "#E5E7EB",
                                height: "auto",
                                borderWidth: "1px",
                                borderRadius: "12px",
                                borderStyle: "solid",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                overflow: "hidden",
                            }}
                        >
                            {/* Avatar and Assistant Details */}
                            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mr: 6, width: "auto" }}>
                                <Avatar
                                    alt={assistantDetails?.Name}
                                    src={assistantDetails.Logo?.fileUrl}
                                    sx={{ width: 80, height: 80 }}
                                />
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    {/* Assistant Name */}
                                    <Typography variant="h5">
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                            <Box
                                                sx={{
                                                    maxWidth: "40vw",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "wrap",
                                                }}
                                            >
                                                {assistantDetails?.Name}
                                                {permissions?.includes("update_assistant") && (
                                                    <BorderColorIcon
                                                        onClick={() => {
                                                            handleClickOpen();
                                                            handleMenuClose();
                                                        }}
                                                        sx={{
                                                            marginLeft: "0.5rem",
                                                            cursor: "pointer",
                                                            fontSize: 20,
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                    </Typography>

                                    {/* Tags and Id of the Assistant */}
                                    <Box sx={{ display: "flex", alignItems: "center", columnGap: "0.5rem", mt: 1 }}>
                                        <ClipboardBox id={assistantDetails._id} />
                                        <Chip label={assistantDetails.Category} size="small" sx={ChipSx} />
                                        <Chip size="small" label={capitalizeFirstLetter(assistantDetails.Type)} sx={ChipSx} />
                                    </Box>
                                </Box>
                            </Box>

                            {/* Buttons and Actions */}
                            <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                                {/* Assistant Actions Buttons */}
                                <Box sx={{ display: "flex", gap: "1rem", width: "auto" }}>
                                    {/* Try Assistant Button */}
                                    <Button
                                        variant="outlined"
                                        startIcon={<AutoAwesomeIcon />}
                                        onClick={handleDrawerOpen}
                                        sx={{
                                            color: "#02042D",
                                            backgroundColor: "#FFFFFF",
                                            borderColor: "#02042D",
                                            textTransform: "none",
                                            borderRadius: 999,
                                            padding: "8px 24px",
                                            fontSize: 13,
                                            fontWeight: 500,
                                            width: "auto",
                                            whiteSpace: 'nowrap',  // Prevents text from wrapping
                                            "&:hover": {
                                                borderColor: "#02042D",
                                                backgroundColor: "#FAFAFA",
                                            },
                                        }}
                                    >
                                        Try Assistant
                                    </Button>

                                            {/* Chat Drawer for Trying Assistant */}
                                    <ChatDrawer
                                        open={isDrawerOpen}
                                        onClose={handleDrawerClose}
                                        avatar={assistantDetails?.Logo?.fileUrl}
                                        name={assistantDetails?.Name}
                                        wsUrl={`${process.env.REACT_APP_VOICE_URL}`}
                                        callConfig={assistantConfig}
                                        handleWebCall={handleWebCall} // Add this line
                                    />

                                    {/* Share Assistant Button */}
                                    <Button
                                        variant="outlined"
                                        startIcon={<LinkIcon />}
                                        onClick={handleShareAssistant}
                                        sx={{
                                            whiteSpace: 'nowrap',  // Prevents text from wrapping
                                            width: "auto",
                                            color: "#02042D",
                                            backgroundColor: "#FFFFFF",
                                            borderColor: "#E5E7EB",
                                            textTransform: "none",
                                            borderRadius: "8px",
                                            padding: "8px 24px",
                                            fontSize: 13,
                                            fontWeight: 500,
                                            "&:hover": {
                                                borderColor: "#02042D",
                                                backgroundColor: "#FAFAFA",
                                            },
                                        }}
                                    >
                                        Share Assistant
                                    </Button>    

                                    {/* Publish Button */}
                                    <Button
                                        variant="contained"
                                        disabled={loading}
                                        onClick={handleUpdateSave}
                                        sx={{
                                            whiteSpace: 'nowrap',  // Prevents text from wrapping
                                            bgcolor: "#02042D",
                                            color: "#FFF",
                                            width: "auto",
                                            textTransform: "none",
                                            borderRadius: 999,
                                            padding: "8px 24px",
                                            fontSize: 13,
                                            "&:hover": {
                                                bgcolor: "#010320",
                                            },
                                            "&.Mui-disabled": {
                                                bgcolor: "#e0e0e0",
                                                color: "#9e9e9e",
                                            },
                                        }}
                                    >
                                        {loading ? (
                                            <CircularProgress
                                                size={24} // Size of the loader
                                                sx={{ color: "#fff" }} // Color of the loader
                                            />
                                        ) : (
                                            "Publish"
                                        )}
                                    </Button>  
                            </Box>
                            
                            {/* Share Assistant Component */}
                            <ModalShare isOpen={isShareAssistantModalOpen} onClose={() => setIsShareAssistantModalOpen(false)} assistantId={assistantDetails._id} />

                            {/* Menu Component */}
                            <Box>
                                {(permissions?.includes("delete_assistant") || 
                                permissions?.includes("duplicate_assistant") || 
                                permissions?.includes("assign_assistant_to_company") || 
                                permissions?.includes("assign_assistant_to_demo")) && (
                                    <IconButton onClick={handleMenuOpen}>
                                    <MoreVert />
                                    </IconButton>
                                )}

                                {/* Menu Component */}
                                <Menu
                                anchorEl={menuAnchorEl}
                                open={Boolean(menuAnchorEl)}
                                onClose={handleMenuClose}
                                PaperProps={{
                                    elevation: 2,
                                    sx: {
                                        overflow: 'visible',
                                        mt: 1.2, // Slightly reduced margin top
                                        borderRadius: '14px', // Slightly tighter border radius
                                        minWidth: '200px', // Reduced width
                                        '& .MuiList-root': {
                                        padding: '6px' // Slightly reduced padding
                                        },
                                        '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 18,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                        },
                                    },
                                    }}
                                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                 >
                                        {permissions?.includes("delete_assistant") && 
                                        <MenuItem onClick={() => { handleOpenDeleteModal(); handleMenuClose(); }} sx={menuItemSx}>
                                            <Delete fontSize="small" style={{ marginRight: "0.5rem" }} /> Delete
                                        </MenuItem>}

                                        {permissions?.includes("duplicate_assistant") && 
                                        <MenuItem onClick={() => { handleDuplicate(); handleMenuClose(); }} sx={menuItemSx}>
                                            <CopyAll fontSize="small" style={{ marginRight: "0.5rem" }} /> Duplicate
                                        </MenuItem>}

                                        {permissions?.includes("assign_assistant_to_company") && 
                                        <MenuItem onClick={() => {
                                            setIsAssignModalOpen(true)
                                            setMenuAnchorEl(null);
                                        }}
                                        sx={menuItemSx}
                                        >
                                            <AssistantOutlined fontSize="small" sx={{ mr: ".5rem" }} /> Assign Assistant
                                        </MenuItem>
                                        }

                                        {permissions?.includes("assign_assistant_to_demo") && 
                                        <MenuItem  sx={menuItemSx} >
                                            <Box style={{ marginLeft: '-0.5rem' }}>
                                                <Switch
                                                    checked={isDemo}
                                                    onChange={(e) => { setIsDemo(e.target.checked); toggleAssistant(); }}
                                                    sx={{
                                                        '& .MuiSwitch-switchBase.Mui-checked': {
                                                            color: '#02042d',
                                                        },
                                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                            backgroundColor: '#02042d',
                                                        },
                                                    }}
                                                />

                                                Demo
                                            </Box>
                                        </MenuItem>}
                                </Menu>
                            </Box>
                            </Box>
                    </Box>
                <ViewAssistant assistant={assistantDetails} actions={actions} />
            </Box>
        )
    }

            {/* Assisn Assistant Modal */}
            <AssignAssistantModal
                open={isAssignModalOpen}
                handleClose={handleCloseAssignModal}
                assistantDetails={assistantDetails}
                organization={organization}
                setOrganization={setOrganization}
                organizationList={organizationList}
                handleAssign={handleAssign}
                loading={loading}
            />
            
            {/* Delete confirmation Modal */}
            <DeleteConfirmationModal
                open={isDeleteModalOpen}
                handleClose={handleCloseDeleteModal}
                handleDelete={performDelete}
            />

            {/* Profile update modal */}
            <UpdateAssistantModal
                open={open}
                handleClose={handleClose}
                assistantDetails={assistantDetails}
                logo={logo}
                handleLogoUpload={handleLogoUpload}
                assistantName={assistantName}
                setAssistantName={setAssistantName}
                assistantType={assistantType}
                setAssistantType={setAssistantType}
                assistantCategory={assistantCategory}
                setAssistantCategory={setAssistantCategory}
                otherCategory={otherCategory}
                setOtherCategory={setOtherCategory}
                assistantDescription={assistantDescription}
                setAssistantDescription={setAssistantDescription}
                validationError={validationError}
                setValidationError={setValidationError}
                loading={loading}
                setLoading={setLoading}
                handleAssistantProfileUpdate={handleAssistantProfileUpdate}
            />
        </>
    );
};

export default AssistantDetails;
